import React from 'react';
function Footer() {
    const handle_wallet_Click = () => {
        console.log('div clicked!');
    };
    return (
        <footer className="footer ltr-direction fixed bottom-0 left-0 right-0 z-10 w-full bg-gray-900">
            <div className="container ">
                <ul className="middllink  grid grid-cols-5 justify-between  font-bold text-center ">
                    <li>
                        <div
                            onClick={handle_wallet_Click}
                            className="flex flex-col items-center mt-8 cursor-pointer  text-blue-400  text-xs rounded-lg transition"
                        >
                            <img
                                src="./paysera/footer_1.png"
                                alt="Wallet"
                                className="w-7 h-7 mb-1"
                            />

                            <span>Wallet</span>
                        </div>
                    </li>
                    <li>
                        <div
                            onClick={handle_wallet_Click}
                            className="flex flex-col items-center mt-8 cursor-pointer text-center  text-gray-400 text-xs  rounded-lg transition"
                        >
                            <img
                                src="./paysera/footer_2.png"
                                alt="Cards"
                                className="w-9 h-7 mb-1"
                            />

                            <span>Cards</span>
                        </div>
                    </li>

                    <li>
                        <div
                            onClick={handle_wallet_Click}
                            className="flex flex-col items-center mt-5 mb-2 cursor-pointer   text-gray-400 text-xs  rounded-lg transition"
                        >
                            <img
                                src="./paysera/footer_3.png"
                                alt="Transfer"
                                className="w-14 h-14"
                            />

                            <span>Transfer</span>
                        </div>
                    </li>

                    <li>
                        <div
                            onClick={handle_wallet_Click}
                            className="flex flex-col items-center mt-7 cursor-pointer  text-gray-400 text-xs  rounded-lg transition"
                        >

                            <div className="w-8 h-8  rounded-full flex items-center   cursor-pointer justify-center text-gray-800 text-2xl bg-gray-500">
                                +
                            </div>

                            <span className='mt-2'>Top Up</span>
                        </div>
                    </li>


                    <li>
                        <div
                            onClick={handle_wallet_Click}
                            className="flex flex-col items-center mt-7 cursor-pointer   text-gray-400 text-xs  rounded-lg transition"
                        >
                            <img
                                src="./paysera/footer_4.png"
                                alt="More"
                                className="w-9 h-7 mb-1"
                            />

                            <span>More</span>
                        </div>
                    </li>

                </ul>
            </div>
        </footer >
    );
}
export default Footer;